import React from "react";
import Skeleton from "react-loading-skeleton";
import moment from "moment";

const formatPolicyDate = (value) => {
  const parsed = moment(value, ["M/D/YYYY h:mm:ss A", moment.ISO_8601], true);
  return parsed.isValid() ? parsed.format("DD MMM YYYY, hh:mm A") : value;
};

export const CancellationPolicy = ({ data, loading, error }) => {
  const policies = Array.isArray(data?.policies) ? data.policies : [];

  if (!loading && !error && policies.length === 0 && !data?.html) {
    return null;
  }

  return (
    <div className="hw-passenger--listShow__widget">
      <div className="hw-black900 hw-text20 hw-fontBold mb-2">
        Cancellation Policy
      </div>

      {loading ? (
        <Skeleton width={"100%"} height={"18px"} count={2} />
      ) : error ? (
        <div className="hw-text14 hw-black800">{error}</div>
      ) : policies.length > 0 ? (
        <ul className="hw-cancellation--list">
          {policies.map((p, i) => (
            <li key={i}>
              <span className="hw-fontWeight--500">
                {formatPolicyDate(p?.fromDate)} &ndash; {formatPolicyDate(p?.toDate)}:
              </span>{" "}
              {Number(p?.percentage) === 0
                ? "Free cancellation (no charges)."
                : `${p?.percentage}% cancellation charge.`}
            </li>
          ))}
        </ul>
      ) : (
        <div
          className="hw-cancellation--list"
          dangerouslySetInnerHTML={{ __html: data?.html }}
        />
      )}
    </div>
  );
};
